import React from 'react';

import { Filter } from '@gogame/filters';
import { dateFNS } from '@gogame/intl-ts';

import {
  FILTER_PERIOD,
  FILTER_MANAGERS,
  FILTER_USERS,
  FILTER_PAGE,
  FILTER_TYPE,
} from 'scenes/AuditLogs/constants';
import {
  loadPages,
  loadTypes,
  loadAllUsers,
  loadManagers,
} from 'scenes/AuditLogs/sources/filters';

const DEPENDENCIES = {
  [FILTER_USERS]: [FILTER_MANAGERS],
  [FILTER_TYPE]: [FILTER_PAGE],
};

export const Period = (props) => (
  <Filter.DateRangePicker
    timeZone={'utc'}
    title={'Period'}
    placeholder={'All'}
    name={FILTER_PERIOD}
    variant={'outlined'}
    maxDate={dateFNS.endOfYear(new Date())}
    {...props}
  />
);

export const Managers = (props) => (
  <Filter.MultiSelect
    title={'Managers'}
    name={FILTER_MANAGERS}
    variant={'outlined'}
    placeholder={'All'}
    source={loadManagers}
    withAll={false}
    {...props}
  />
);

export const Users = (props) => (
  <Filter.MultiSelect
    title={'Users'}
    placeholder={'All'}
    name={FILTER_USERS}
    variant={'outlined'}
    source={loadAllUsers}
    depends={DEPENDENCIES[FILTER_USERS]}
    {...props}
  />
);

export const Pages = (props) => (
  <Filter.Select
    title={'Page'}
    placeholder={'All'}
    name={FILTER_PAGE}
    variant={'outlined'}
    source={loadPages}
    {...props}
  />
);

export const Types = (props) => (
  <Filter.Select
    title={'Type'}
    placeholder={'All'}
    name={FILTER_TYPE}
    variant={'outlined'}
    depends={DEPENDENCIES[FILTER_TYPE]}
    source={loadTypes}
    {...props}
  />
);
